import { Skeleton } from '@mui/material'
import { Card, LoadingTable } from 'components/core-v2'

import { COLUMN_DEFS } from './columns'

export const Loading = () => (
  <Card.Wrapper>
    <Card.Header>
      <Skeleton height="15px" variant="rectangular" width="160px" />
    </Card.Header>
    <LoadingTable agGridProps={{ headerHeight: 60, columnDefs: COLUMN_DEFS }} height="400px" />
  </Card.Wrapper>
)
